import { render } from "./ReviewMemorialView.vue?vue&type=template&id=b92b0dfa"
import script from "./ReviewMemorialView.vue?vue&type=script&lang=js"
export * from "./ReviewMemorialView.vue?vue&type=script&lang=js"

import "./ReviewMemorialView.vue?vue&type=style&index=0&id=b92b0dfa&lang=css"

import exportComponent from "/tmp/build_37390889/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__